import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import { ReportService } from '../../report.service';
import { Creditor } from 'projects/_base-shared/models/Entity/Creditor';
import { CreditorService } from '../../../creditor/creditor.service';
import { AppSelectOption } from '../../../../../../../_base-shared/contracts/common.interface';
import { Status } from 'projects/_base-shared/models/Status/Status';
import { StatusCategory } from 'projects/_base-shared/models/Status/StatusCategory';

@Component({
  standalone: false,
  selector:    'bulk-dm-report-modal',
  templateUrl: './creditor-debt-modal.component.html',
  styleUrls:   ['./creditor-debt-modal.component.scss'],
})
export class CreditorDebtModalComponent implements OnInit {
  public form: UntypedFormGroup;
  public isLoading = 0;
  public creditors: Array<Creditor> = [];
  public statusCategories: Array<StatusCategory>         = [];
  public filteredStatusCategories: Array<StatusCategory> = [];
  public allStatuses: Array<Status>                      = [];

  constructor(
      private toast: ToastrService,
      private reportService: ReportService,
      private fb: UntypedFormBuilder,
      private translate: TranslateService,
      public dialogRef: MatDialogRef<CreditorDebtModalComponent>,
      private creditorService: CreditorService,
      @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
  }

  ngOnInit(): void {
    this.fetchCreditors();
    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group({
      creditor_id: [null, Validators.required],
    //   start_date:  [null, Validators.required],
    //   end_date:    [null, Validators.required],
    });
  }

  sendReportData() {
    if (!this.form.valid) {
      return;
    }

    const requestData = {
      creditor_id: this.form.get('creditor_id').value,
    //   start_date:  this.form.value.start_date.toISOString(),
    //   end_date:    this.form.value.end_date.toISOString(),
    };
    this.isLoading++;
    this.reportService.generateCreditorDebtReport(requestData).pipe(finalize(() => this.isLoading--))
        .subscribe(
            res => {
              this.toast.success(res.message);
              this.dialogRef.close();
            },
            err => {
              console.error(err);
              this.toast.error('Failed to generate report');
            },
        );
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  private fetchCreditors() {
    this.isLoading++;
    this.creditorService.index({select_all: 1, active: 1}).pipe(finalize(() => this.isLoading--)).subscribe(
        result => this.creditors = result.data,
        err => console.error(err),
    );
  }
}
